<ul class="layout-tabmenu-nav">
    <li class="sidebar-group">
        <mat-button-toggle-group #survivalHorozonViewModeGroup="matButtonToggleGroup" (change)="onSurvivalHorizonViewModeChange($event)"
            [vertical]="true">
            <mat-button-toggle class="dashboardOptionSidebar" value="live" [checked]="survivalHorizonViewMode == 'live'" matTooltip="Live Survival Horizon Mode"
                matTooltipPosition="right">
                <mat-icon>wifi_tethering</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO'" class="dashboardOptionSidebar" value="compare" [checked]="survivalHorizonViewMode == 'compare'"
                matTooltip="Review Position Changes" matTooltipPosition="right">
                <mat-icon>compare_arrows</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle class="dashboardOptionSidebar" value="account-balance" [checked]="survivalHorizonViewMode == 'account-balance'"
                matTooltip="Review Account Balances" matTooltipPosition="right">
                <mat-icon>account_balance</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle class="dashboardOptionSidebar" value="buffer" [checked]="survivalHorizonViewMode == 'buffer'" matTooltip="Liquidity Buffer"
                matTooltipPosition="right">
                <mat-icon>layers</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <li *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO'" class="sidebar-group">
        <mat-button-toggle-group #ladderViewModeGroup="matButtonToggleGroup" (change)="onLadderViewModeChange($event)" [vertical]="true">
            <mat-button-toggle class="dashboardOptionSidebar" value="datatable" [checked]="ladderViewMode == LadderViewMode.DATATABLE"
                matTooltip="Display as Table" matTooltipPosition="right">
                <mat-icon>grid_on</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle class="dashboardOptionSidebar" value="chart" [checked]="ladderViewMode == LadderViewMode.CHART" matTooltip="Display as Chart"
                matTooltipPosition="right">
                <mat-icon>show_chart</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
    <li *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO' && strategies" class="sidebar-group-clear">
        <mat-menu #menu="matMenu" xPosition="before" [overlapTrigger]="false">
            <button *ngFor="let strategy of strategies" mat-menu-item (click)="onStrategySelected(strategy)">
                <span>{{strategy.displayName}}</span>
            </button>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Bucketing Strategy" matTooltipPosition="right">
            <mat-icon>local_drink</mat-icon>
        </button>
    </li>
    <li *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO'" class="sidebar-group-clear">
        <button mat-icon-button class="action-button" (click)="openManualCorrectionDialog()" matTooltip="Manual Correction" matTooltipPosition="right">
            <mat-icon>mode_edit</mat-icon>
        </button>
    </li>
    <li *ngIf="profileType !== 'MULTI_ENTITY_NOSTRO'" class="sidebar-group-clear">
        <button mat-icon-button class="action-button" (click)="openAsOfDateDialog()" matTooltip="Replay the Day" matTooltipPosition="right">
            <mat-icon>date_range</mat-icon>
        </button>
    </li>
    <li class="sidebar-group-clear">
        <button mat-icon-button class="action-button" (click)="openTransactionSearchDialog()" matTooltip="Transaction Search" matTooltipPosition="right">
            <mat-icon>search</mat-icon>
        </button>
    </li>
    <!-- <li *ngIf="profileType === 'MULTI_ENTITY_NOSTRO' && tables" class="sidebar-group-clear">
        <mat-menu #menu="matMenu" xPosition="before" [overlapTrigger]="false">
            <button *ngFor="let table of tables" mat-menu-item (click)="onTableExport(table)">
                <span>{{table.name}}</span>
            </button>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Download CSVs" matTooltipPosition="right">
            <mat-icon>file_download</mat-icon>
        </button>
    </li> -->
    <!-- <li [ngClass]="{'active-item':app.activeTabIndex === 1}">
                <a href="#" class="ripplelink tabmenuitem-link" (click)="app.onTabClick($event, 1)"><i class="fa fa-calendar-o"></i></a>
                <div class="layout-tabmenu-tooltip">
                    <div class="layout-tabmenu-tooltip-arrow"></div>
                    <div class="layout-tabmenu-tooltip-text">Inbox</div>
                </div>
            </li>
            <li [ngClass]="{'active-item':app.activeTabIndex === 2}">
                <a href="#" class="ripplelink tabmenuitem-link" (click)="app.onTabClick($event, 2)"><i class="fa fa-calendar"></i></a>
                <div class="layout-tabmenu-tooltip">
                    <div class="layout-tabmenu-tooltip-arrow"></div>
                    <div class="layout-tabmenu-tooltip-text">Calendar</div>
                </div>
            </li>
            <li [ngClass]="{'active-item':app.activeTabIndex === 3}">
                <a href="#" class="ripplelink tabmenuitem-link" (click)="app.onTabClick($event, 3)"><i class="fa fa-image"></i></a>
                <div class="layout-tabmenu-tooltip">
                    <div class="layout-tabmenu-tooltip-arrow"></div>
                    <div class="layout-tabmenu-tooltip-text">Projects</div>
                </div>
            </li>
            <li [ngClass]="{'active-item':app.activeTabIndex === 4}">
                <a href="#" class="ripplelink tabmenuitem-link" (click)="app.onTabClick($event, 4)"><i class="fa fa-language"></i></a>
                <div class="layout-tabmenu-tooltip">
                    <div class="layout-tabmenu-tooltip-arrow"></div>
                    <div class="layout-tabmenu-tooltip-text">Updates</div>
                </div>
            </li> -->


    <!-- <li [ngClass]="{'active-item':app.activeTabIndex === 2}">
        <a href="#" class="ripplelink tabmenuitem-link" (click)="app.onTabClick($event, 2)">
            <i class="fa fa-calendar"></i>
        </a>
        <div class="layout-tabmenu-tooltip">
            <div class="layout-tabmenu-tooltip-arrow"></div>
            <div class="layout-tabmenu-tooltip-text">Calendar</div>
        </div>
    </li> -->
</ul>